import { FontSize200, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
const costcoTravelTextStyles = {
  color: ColorGray900,
  fontSize: FontSize200
};
export {
  costcoTravelTextStyles
};
